interface Props {
  className?: string
  children: React.ReactNode
}

interface UnderlineProps {
  underline?: 'on' | 'off' | 'white' | 'black' | 'gradient'
}

export const Underline = ({ underline = 'gradient' }: UnderlineProps) =>
  underline !== 'off' ? (
    <div
      className={`h-1 w-14 flex-shrink-0 ${
        underline === 'gradient'
          ? '[background-image:linear-gradient(90deg,_#fc2548,_#f11fad)]'
          : underline === 'white'
            ? 'bg-white'
            : 'bg-black'
      }`}
    />
  ) : null

export const Text = {
  H1: ({ className, children, underline }: Props & UnderlineProps) => (
    <div
      className={`font-merriweather-sans flex flex-col gap-y-[8px] text-4xl md:text-5xl font-bold leading-[1.4] ${className}`}
    >
      <span>{children}</span>
      <Underline underline={underline} />
    </div>
  ),
  H2: ({ className, children, underline }: Props & UnderlineProps) => (
    <div
      className={`font-merriweather-sans flex flex-col gap-y-[8px] text-3xl lg:text-4xl font-bold leading-[1.8] ${className}`}
    >
      <span>{children}</span>
      <Underline underline={underline} />
    </div>
  ),
  H3: ({ className, children, underline }: Props & UnderlineProps) => (
    <div
      className={`font-merriweather-sans flex flex-col gap-y-[8px] text-2xl lg:text-4xl font-semibold leading-[1.8] tracking-[12px] uppercase ${className}`}
    >
      {children}
      <Underline underline={underline} />
    </div>
  ),
  H4: ({ className, children }: Props) => (
    <div className={`md:text-xl text-lg font-bold leading-[1.8] ${className}`}>{children}</div>
  ),
  H5: ({ className, children, gradient = false }: Props & { gradient?: boolean }) => (
    <div className='text-[15px] font-bold uppercase leading-[1.8] text-transparent'>
      <span
        className={`bg-clip-text ${
          gradient
            ? '[background-image:linear-gradient(90deg,_#fc2548,_#f11fad)]'
            : 'text-[darkviolet]'
        } ${className}`}
      >
        {children}
      </span>
    </div>
  ),
  Gradient: ({ className, children }: Props) => (
    <span className={`text-transparent ${className}`}>
      <span className='bg-clip-text [background-image:linear-gradient(90deg,_#fc2548,_#f11fad)]'>
        {children}
      </span>
    </span>
  ),
  Body: ({ className, children }: Props) => (
    <div
      className={`font-merriweather-sans text-[16px] lg:text-[17px] leading-[1.8] opacity-80 ${className}`}
    >
      {children}
    </div>
  ),
  Verse: ({ className, children }: Props) => (
    <div
      className={`font-montserrat font-semibold text-[16px] lg:text-[17px] leading-[1.8] opacity-80 ${className}`}
    >
      {children}
    </div>
  ),
  BodyLarge: ({ className, children }: Props) => (
    <div className={`font-merriweather-sans text-[17px] lg:text-[18px] leading-[1.8] ${className}`}>
      {children}
    </div>
  ),
  Caption: ({ className, children }: Props) => (
    <div className={`font-merriweather-sans text-[15px] ${className}`}>{children}</div>
  ),
}
